import { gql } from '@apollo/client';
import { USER_FRAGMENT } from './fragments';

export const SIGN_IN_CLIENT_MUTATION = gql`
  ${USER_FRAGMENT}

  mutation SignInClient($email: String!, $password: String!, $device: RegisterFCMDeviceInput) {
    __typename
    signInClient(email: $email, password: $password, device: $device) {
      __typename
      ... on SignInClient {
        message
        user {
          ...UserFragment
        }
        accessToken
        refreshToken
      }
      ... on Error {
        __typename
        errorCode
        message
      }
    }
  }
`;

export const SIGN_UP_CLIENT_MUTATION = gql`
  ${USER_FRAGMENT}

  mutation SignUpClient($data: CreateClientInput!) {
    __typename
    signUpClient(data: $data) {
      __typename
      ... on CreateClientExternal {
        message
        version
        account {
          id
          companyName
          timeZone
        }
        user {
          ...UserFragment
        }
        accessToken
        refreshToken
      }
      ... on Error {
        __typename
        errorCode
        message
      }
    }
  }
`;

export const UPDATE_USER = gql`
  mutation UpdateUser($data: UpdateUserInput) {
    updateUser(data: $data) {
      ... on CreateUpdateUser {
        message
        version
        user {
          id
          firstName
          lastName
          email
          avatarUrl
          locale
          timeZone
          role
          isWelcomeScreenClosed
          analyticsConsent
          analyticsConsentAt
          analyticsConsentVersion
          settings {
            dashboardSettings {
              showTimer
              showClock
              showDate
              showSeconds
              upcomingJobsWindow
              dashboardMaxListLength
              dashboardShowOnlyNew
            }
          }
        }
      }
      ... on Error {
        message
      }
    }
  }
`;

export const LOGOUT_MUTATION = gql`
  mutation Logout {
    __typename
    logout {
      __typename
      success
      message
    }
  }
`;

export const UPDATE_USER_AVATAR = gql`
  mutation UpdateUserAvatar($data: UpdateUserAvatarInput) {
    updateUserAvatar(data: $data) {
      ... on UpdateUserAvatar {
        message
        avatarUrl
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
`;

export const UPDATE_USER_PASSWORD = gql`
  mutation UpdateUserPassword($data: UpdateUserPasswordInput) {
    updateUserPassword(data: $data) {
      ... on UpdateUserPassword {
        message
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
`;

export const REMOVE_USER_AVATAR = gql`
  mutation RemoveUserAvatar {
    removeUserAvatar {
      ... on RemoveUserAvatar {
        message
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
`;

export const DELETE_CLIENT_ACCOUNT = gql`
  mutation DeleteClientAccount($deleteClientAccountId: ID!) {
    deleteClientAccount(id: $deleteClientAccountId) {
      ... on DeleteClientAccount {
        message
        version
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
`;

export const RESEND_EMAIL_VERIFICATION = gql`
  mutation ResendEmailVerification {
    resendEmailVerification {
      ... on ResendEmailVerification {
        message
        version
        sent
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
`;
